import { forwardRef } from 'react'
import './Hero.css'

interface HeroProps {
  id: string
}

const Hero = forwardRef<HTMLDivElement, HeroProps>(({ id }, ref) => {
  return (
    <section
      ref={ref}
      id={id}
      className="hero"
      aria-labelledby="hero-title"
    >
      <div className="hero__bg" aria-hidden="true" />
      <div className="container hero__content">
        <div className="hero__text animate-in">
          <h1 id="hero-title" className="hero__title">
            Samtalsterapi
            <br />
            <span className="hero__title-highlight">i centrala Malmö</span>
          </h1>
          <p className="hero__description animate-in animate-delay-1">
            Jag erbjuder individuell terapi och parterapi samt behandling och utbildning i grupp,
            utifrån psykodynamiska samtal, affektfokuserad terapi, panikfokuserad psykodynamisk
            terapi (PFPP), mindfulness och ACT – på mottagning i centrala Malmö eller online.
          </p>
          <div className="hero__actions animate-in animate-delay-2">
            <a href="#contact" className="btn btn--primary btn--large" data-section="contact">
              Kontakta mig för ett första möte
            </a>
            <a href="#services" className="btn btn--secondary btn--large" data-section="services">
              Se behandlingar
            </a>
          </div>
        </div>
        <div className="hero__image animate-in animate-delay-1">
          <img
            src="/images/hero-forest.jpg"
            alt="Stig genom en grön bokskog"
            className="hero__photo"
            decoding="async"
          />
        </div>
      </div>
      <div className="hero__scroll-indicator" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 5v14M19 12l-7 7-7-7" />
        </svg>
      </div>
    </section>
  )
})

Hero.displayName = 'Hero'

export default Hero